import type { PropsWithChildren } from "react";
import React from "react";

import { GeniusChat } from "components/GeniusChat/GeniusChat";
import { Smallprint } from "components/Layouts/Smallprint";
import { StickyFooterWrapper } from "components/Layouts/StickyFooter";
import { NotificationsBanner } from "components/NotificationsBanner/NotificationsBanner";
import { useLocale } from "hooks";
import { color } from "lib/theme/theme.css";
import { useHasMounted } from "utils/wrappers";
import { CountryRedirectModal } from "components/Layouts/CountryRedirectModal";

import {
  container,
  pageWrapper,
  smallPrintContainer,
  trustPilotWidgetContainer
} from "./style.css";
import { MemberModals } from "../../../packages/membership/components/MemberModals/MemberModals";
import { TrustPilotReviewWidget } from "@shared/ui.components";

type Props = PropsWithChildren & {
  showTrustPilotReviews?: boolean;
  trustPilotBackgroundColor?: string;
  disableBanner?: boolean;
  showChat?: boolean;
  showStickyFooter?: boolean;
};

declare global {
  interface Window {
    zE: any;
  }
}

export const DefaultLayout: React.FC<Props> = ({
  children,
  showTrustPilotReviews = false,
  trustPilotBackgroundColor = color.backgroundInverse,
  showChat = false,
  showStickyFooter = true
}) => {
  const hasMounted = useHasMounted();
  const locale = useLocale();

  return (
    <div className={container} data-testid="DefaultLayout">
      <NotificationsBanner />
      <MemberModals />
      <div className={pageWrapper}>{children} </div>
      {showStickyFooter && hasMounted && <StickyFooterWrapper />}

      {locale === "en-GB" && showTrustPilotReviews && (
        <div
          className={trustPilotWidgetContainer}
          data-testid="TrustPilotReviews"
        >
          <TrustPilotReviewWidget
            trustPilotBackgroundColor={trustPilotBackgroundColor}
          />
        </div>
      )}
      <div className={smallPrintContainer} data-testid="SmallprintContainer">
        <Smallprint />
      </div>
      {showChat && <GeniusChat />}
      <CountryRedirectModal />
    </div>
  );
};
